module.exports = __webpack_public_path__ + "img/bank-connected-big.da6e92d2.svg";